import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import moment from 'moment/moment';
import { RootState } from '../app.store';
import { getFiscalWeekStartDateList,getDailyGrainDateList } from '../../../Utils/DateUtils';
import { Constants } from '../../../common/constants';

export interface DateNavigationState {
  startDate: string;
  endDate: string;
  numberOfWeeks: number;
  fiscalWeekStartDateList: string[];
  dailyGrainDateList: string[];
}

const initStartDate = new Date();
const initNumberOfWeeks = 2;
const initialDateNavigationState: DateNavigationState = {
    startDate: moment(initStartDate).utc().format(Constants.DATE_FORMAT),
    endDate:  moment(initStartDate).utc()
    .add(initNumberOfWeeks, 'weeks')
    .format(Constants.DATE_FORMAT),
    numberOfWeeks: initNumberOfWeeks,
    fiscalWeekStartDateList: getFiscalWeekStartDateList(initStartDate.toDateString(), initNumberOfWeeks),
    dailyGrainDateList: getDailyGrainDateList(initStartDate.toDateString(), initNumberOfWeeks),
};

export const dateNavigationSlice = createSlice({
  name: 'dateNavigationUpdate',
  initialState: initialDateNavigationState,
  reducers: {
    updateDates: (state, action: PayloadAction<{ startDate: string; numberOfWeeks: number }>) => {
      const startDate = new Date(action.payload.startDate);
      startDate.setHours(0, -startDate.getTimezoneOffset(), 0, 0);

      const endDate = new Date(startDate);
      endDate.setHours(0, -endDate.getTimezoneOffset(), 0, 0);

      state.startDate = moment(startDate).utc().format(Constants.DATE_FORMAT);
      state.endDate = moment(endDate).utc()
        .add(action.payload.numberOfWeeks, 'weeks')
        .format(Constants.DATE_FORMAT);
      state.numberOfWeeks = action.payload.numberOfWeeks;
      state.fiscalWeekStartDateList = getFiscalWeekStartDateList(action.payload.startDate, action.payload.numberOfWeeks);
      state.dailyGrainDateList = getDailyGrainDateList(action.payload.startDate, action.payload.numberOfWeeks);
    }
  }
});

export const {
    updateDates
} = dateNavigationSlice.actions;


export const fiscalWeekStartDateListSelector = (state: RootState) => state.dateNavigation.fiscalWeekStartDateList;
export const dailyGrainDateListSelector = (state: RootState) => state.dateNavigation.dailyGrainDateList;

export const dateRangeSelector = (state: RootState) => ({
    startDate: state.dateNavigation.startDate,
    endDate: state.dateNavigation.endDate
});

export default dateNavigationSlice.reducer;
